import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { filter, map } from '@beef/utils';
import { flattenGroup, groupByField } from "../helpers";
import { PARAM_EMPTY_VALUE } from "../constants";
import { PARAM_FIELD_SIZE } from "./constants";
import { BuilderExtension } from "../BuilderExtension";
import { AdaptiveDecorator } from "./AdaptiveDecorator";
import { ChildUtils } from "../ChildUtils";
import { AdaptiveProjection } from "./AdaptiveProjection";
export var AdaptiveExtension = /*#__PURE__*/function (_BuilderExtension) {
  _inherits(AdaptiveExtension, _BuilderExtension);
  var _super = _createSuper(AdaptiveExtension);
  function AdaptiveExtension() {
    _classCallCheck(this, AdaptiveExtension);
    return _super.apply(this, arguments);
  }
  _createClass(AdaptiveExtension, [{
    key: "create",
    value: function create(data, params) {
      var _this = this;
      if (typeof data === 'undefined' || !Object.keys(data).length) {
        console.assert(typeof data === 'undefined', 'Обнаружен пустой массив свойств, подобное состояние недопустимо');
        return new AdaptiveDecorator(_defineProperty({}, PARAM_EMPTY_VALUE, this.next.create(undefined, params)), params, new ChildUtils(this.next));
      }
      var rawGroups = groupByField(data, PARAM_FIELD_SIZE);
      return new AdaptiveDecorator(map(rawGroups, function (elements) {
        return _this.next.create(elements, params);
      }), params, new ChildUtils(this.next));
    }
  }, {
    key: "createProjection",
    value: function createProjection(data, params) {
      var _this2 = this;
      if (typeof data === 'undefined') {
        return new AdaptiveProjection(_defineProperty({}, PARAM_EMPTY_VALUE, this.next.createProjection(undefined, params)), params);
      }
      var rawGroups = groupByField(data, PARAM_FIELD_SIZE);
      return new AdaptiveProjection(map(rawGroups, function (elements) {
        return _this2.next.createProjection(elements, params);
      }), params);
    }
  }, {
    key: "serialize",
    value: function serialize(cls) {
      var _this3 = this;
      var rawGroups = filter(map(cls.value, function (prop) {
        return _this3.next.serialize(prop);
      }), function (value, key) {
        return key !== PARAM_EMPTY_VALUE || typeof value !== 'undefined';
      });
      var result = flattenGroup(cls.getSortedKeys(rawGroups), rawGroups, PARAM_FIELD_SIZE);
      return result.length ? result : undefined;
    }
  }]);
  return AdaptiveExtension;
}(BuilderExtension);